import { List } from "@mui/material"
import { hasRole } from "auth/hasRole"
import { useApi } from "auth/useApi3"
import { AppContext } from "components/AppContextProvider"
import { QuickLink } from "components/List/QuickLink/QuickLink"
import { apiEndpoints } from "generated/apiEndpoints"
import { allRoles } from "generated/roles"
import { allRoutes } from "generated/routes"
import { useContext, useEffect } from "react"
import { useTranslation } from "react-i18next"
export const DashboardQuickLinks = ({ route, title }) => {
  const appContext = useContext(AppContext)
  const isVehicleRegistryAdmin = hasRole(appContext.appUser, allRoles.VehicleRegistryAdmin)
  const isVehicleRegistryReports = hasRole(appContext.appUser, allRoles.VehicleRegistry_Reports)
  const isVehicleRegistryAlarms = hasRole(appContext.appUser, allRoles.VehicleRegistry_Alarms)
  const [userReportTemplates, userReportTemplatesApi] = useApi()
  const { t } = useTranslation()

  useEffect(() => {
    const loadStuff = async () => {
      userReportTemplatesApi.get(apiEndpoints.vehicleregistry.getuserreporttemplates)
    }

    loadStuff()
  }, [userReportTemplatesApi])

  return (
    <List disablePadding>
      <QuickLink
        route={allRoutes.VehicleregistryVehicles}
        text={t("features.title.vehicleregistry", "Vehicle registry")}
      />

      {isVehicleRegistryReports && (
        <QuickLink
          route={allRoutes.VehicleregistryReports}
          text={t("features.title.vehicleregistry_reports", "Reports")}
        />
      )}
      {isVehicleRegistryAlarms && (
        <QuickLink
          route={allRoutes.Vehiclealarm}
          text={t("features.title.vehicleregistry_alarms", "Vehicle alarms")}
        />
      )}
      {isVehicleRegistryReports && isVehicleRegistryAdmin && (
        <>
          <QuickLink
            route={allRoutes.VehicleregistryVehiclesImportvtr}
            text={t("global.import_from_the_transport_agency", "Import from the Transport Agency")}
          />
          <QuickLink
            route={allRoutes.VehicleregistryVehiclesImport}
            text={t("global.import_vehicles", "Import vehicles")}
          />
          <QuickLink
            route={allRoutes.VehicleregistryReportsReporttemplates}
            text={t("global.report_templates", "Report templates")}
          />

          {userReportTemplates.status === 2 &&
            userReportTemplates.data.some((x) => x.name === "Miljörapport: Fordon") && ( //TODO fixa hårdkodning
              <>
                <QuickLink
                  route={allRoutes.VehicleregistryReportsFueldata}
                  text={t("global.tank_files", "Tank files")}
                />
                <QuickLink
                  route={allRoutes.VehicleregistryReportsFueldataImport}
                  text={t("global.import_tank_files", "Import tank files")}
                />
              </>
            )}
          {userReportTemplates.status === 2 &&
            userReportTemplates.data.some((x) => x.name === "Miljörapport: Avtal") && (
              <>
                <QuickLink
                  route={allRoutes.VehicleregistryReportsContract}
                  text={t("settings.user.bpl.working_agreement_types", "Agreement")}
                />
                <QuickLink
                  route={allRoutes.VehicleregistryReportsContractImport}
                  text={t("global.import_agreement", "Import agreement")}
                />
              </>
            )}
        </>
      )}
    </List>
  )
}
